import { type AssetCapabilities } from '@innovyze/lib_asset_schema';

// Whenever a new inspection standard is added to rehab, it should be included in this array
export const supportedInspectionStandards: AssetCapabilities.InspectionsStandards[] =
	['PACP', 'WSA05'];
